import { createFileRoute, notFound } from "@tanstack/react-router";
import { PortalNotFound } from "@/components/PortalNotFound";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/member/$")({
  head: () => pageHead('Member Page Not Found', 'This AKIVA member portal page does not exist.', '/member', true),
  beforeLoad: () => { throw notFound(); },
  notFoundComponent: PortalNotFound,
});
